import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';

@Injectable({ providedIn: 'root' })
export class FeatureFlagService {
  shouldAuthenticateWithVE(): boolean {
    return environment.shouldAuthenticateWithVE;
  }
}
